import React, { createContext, useContext, useState } from 'react';
export { formatCurrency } from './DASIContext';

const withItemFields = (items) =>
  items.map((item) => ({ cleared: false, resolutionMode: null, resolutionReason: null, ...item }));

const buildInitialEntries = () => [
  {
    id: 'CBP-8829102A',
    date: '2026-03-12',
    broker: 'Yusen Logistics',
    recoveryValue: 4500.00,
    deficiencyValue: 5450.00,
    emailTo: 'imports@yusen.com',
    emailSubject: 'PSC Required: Entry CBP-8829102A - Form 7501 Corrections',
    classVectors: [
      { name: 'CI vs. 7501 Line Reconciliation', status: 'pass' },
      { name: '7501 Internal Arithmetic Integrity', status: 'pass' },
      { name: 'Base HTS & Duty Rate Integrity', status: 'pass' },
    ],
    typeAVectors: [
      { name: 'Section 122 Offsets', status: 'pass' },
      { name: 'Chapter 99 & Sec 232 / 301 Audits', status: 'recovery' },
      { name: 'Incoterm / Freight Valuation Variance', status: 'risk' },
      { name: 'Special Program Indicator (SPI) Omissions', status: 'pass' },
      { name: 'Country of Origin (COO) Consistency', status: 'pass' },
      { name: 'MPF / HMF Cap Violations', status: 'pass' },
      { name: 'UOM / Quantity Integrity (Stats. Anomaly)', status: 'pass' },
      { name: 'Date of Export / FX Conversion', status: 'risk' },
    ],
    typeBVectors: [
      { name: 'Exclusion Monitoring (USTR)', status: 'pass' },
      { name: 'Assists & Royalties Predictor', status: 'hitl' },
      { name: 'Related Party / Transfer Pricing Predictor', status: 'pass' },
      { name: 'Buying Commission Predictor', status: 'pass' },
      { name: 'First Sale for Export Predictor', status: 'pass' },
    ],
    exceptions: [
      {
        title: 'Triage Required: Chapter 99 Audits',
        type: 'recovery',
        value: 4500.00,
        cleared: false,
        items: withItemFields([
          { part: 'PN-8890A Actuator', declared: '9903.88.01 (25%)', target: '9902.14.00 (0%)', flag: 'Ch 99 Mismatch', vectorTarget: 'Chapter 99 & Sec 232 / 301 Audits' },
        ]),
        summary: '<strong>[RECOVERY ALERT] Statutory exemption missed.</strong> Active USTR exclusion found. Duty Base: $18,000. Broker paid 25%. Correct rate is 0%.',
        emailSnippet: '<strong>[RECOVERY ALERT] Chapter 99 Error:</strong> Statutory exemption missed. Active USTR exclusion found. Please claim the correct 0% rate, resulting in a <strong>$4,500 Duty Recovery</strong>.<br><br>',
      },
      {
        title: 'Triage Required: Freight Valuation Variance',
        type: 'risk',
        value: 450.00,
        cleared: false,
        items: withItemFields([
          { part: 'Header Level (Freight)', declared: '$4,500.00 Deducted', target: '$0.00 Deducted (FCA)', flag: 'Illegal Deduction', vectorTarget: 'Incoterm / Freight Valuation Variance' },
        ]),
        summary: '<strong>[COMPLIANCE RISK] Valuation Error:</strong> Broker illegally deducted freight charges from an FCA invoice. Duty base undervalued by $4,500.',
        emailSnippet: '<strong>[COMPLIANCE RISK] Valuation Error:</strong> Broker illegally deducted freight charges from an FCA invoice. Please remit the resulting <strong>$450 Duty Deficiency</strong>.<br><br>',
      },
      {
        title: 'Triage Required: FX Conversion',
        type: 'risk',
        value: 5000.00,
        cleared: false,
        items: withItemFields([
          { part: 'FX Rate Date', declared: '2026-03-15 (Arrival)', target: '2026-02-20 (Sailing)', flag: 'FX Date Error', vectorTarget: 'Date of Export / FX Conversion' },
        ]),
        summary: '<strong>[COMPLIANCE RISK] FX Date Error.</strong> Broker used Arrival Date instead of actual Sailing Date for a JPY invoice. Undervalued by $50k.',
        emailSnippet: '<strong>[COMPLIANCE RISK] FX Date Error:</strong> Broker used Arrival Date instead of actual Sailing Date for a JPY invoice. Please correct the date of export and remit the <strong>$5,000 Duty Deficiency</strong>.<br><br>',
      },
    ],
    hitl: [
      {
        title: 'Agentic Predictor: Assists & Royalties',
        desc: '[HITL REQUIRED] Potential Assist detected. Verify if undeclared tooling costs must be added to the dutiable value.',
        actionTitle: 'Verification Required:',
        actionDesc: "A 'Plastic Injection Mold Tooling Amortization' line was flagged on the Commercial Invoice.",
        vectorsTarget: 'Assists & Royalties Predictor',
        hitlType: 'assist',
        type: 'hitl',
        value: 0,
        cleared: false,
        resolutionMode: null,
        resolutionReason: null,
      },
    ],
  },
  {
    id: 'CBP-4492019B',
    date: '2026-03-14',
    broker: 'Kuehne+Nagel',
    recoveryValue: 0.00,
    deficiencyValue: 0.00,
    emailTo: '',
    emailSubject: '',
    classVectors: [
      { name: 'CI vs. 7501 Line Reconciliation', status: 'pass' },
      { name: '7501 Internal Arithmetic Integrity', status: 'pass' },
      { name: 'Base HTS & Duty Rate Integrity', status: 'pass' },
    ],
    typeAVectors: [
      { name: 'Section 122 Offsets', status: 'pass' },
      { name: 'Chapter 99 & Sec 232 / 301 Audits', status: 'pass' },
      { name: 'Incoterm / Freight Valuation Variance', status: 'pass' },
      { name: 'Special Program Indicator (SPI) Omissions', status: 'pass' },
      { name: 'Country of Origin (COO) Consistency', status: 'pass' },
      { name: 'MPF / HMF Cap Violations', status: 'pass' },
      { name: 'UOM / Quantity Integrity (Stats. Anomaly)', status: 'pass' },
      { name: 'Date of Export / FX Conversion', status: 'pass' },
    ],
    typeBVectors: [
      { name: 'Exclusion Monitoring (USTR)', status: 'pass' },
      { name: 'Assists & Royalties Predictor', status: 'pass' },
      { name: 'Related Party / Transfer Pricing Predictor', status: 'pass' },
      { name: 'Buying Commission Predictor', status: 'pass' },
      { name: 'First Sale for Export Predictor', status: 'pass' },
    ],
    exceptions: [],
    hitl: [],
  },
  {
    id: 'CBP-7734110C',
    date: '2026-03-15',
    broker: 'CH Robinson',
    recoveryValue: 450.00,
    deficiencyValue: 0.00,
    emailTo: 'compliance@chrobinson.com',
    emailSubject: 'PSC Required: Entry CBP-7734110C - Form 7501 Corrections',
    classVectors: [
      { name: 'CI vs. 7501 Line Reconciliation', status: 'pass' },
      { name: '7501 Internal Arithmetic Integrity', status: 'pass' },
      { name: 'Base HTS & Duty Rate Integrity', status: 'pass' },
    ],
    typeAVectors: [
      { name: 'Section 122 Offsets', status: 'pass' },
      { name: 'Chapter 99 & Sec 232 / 301 Audits', status: 'pass' },
      { name: 'Incoterm / Freight Valuation Variance', status: 'recovery' },
      { name: 'Special Program Indicator (SPI) Omissions', status: 'pass' },
      { name: 'Country of Origin (COO) Consistency', status: 'pass' },
      { name: 'MPF / HMF Cap Violations', status: 'pass' },
      { name: 'UOM / Quantity Integrity (Stats. Anomaly)', status: 'risk' },
      { name: 'Date of Export / FX Conversion', status: 'pass' },
    ],
    typeBVectors: [
      { name: 'Exclusion Monitoring (USTR)', status: 'pass' },
      { name: 'Assists & Royalties Predictor', status: 'pass' },
      { name: 'Related Party / Transfer Pricing Predictor', status: 'pass' },
      { name: 'Buying Commission Predictor', status: 'hitl' },
      { name: 'First Sale for Export Predictor', status: 'pass' },
    ],
    exceptions: [
      {
        title: 'Triage Required: Freight Valuation Variance',
        type: 'recovery',
        value: 450.00,
        cleared: false,
        items: withItemFields([
          { part: 'U.S. Inland Freight', declared: 'Included in Value', target: 'Non-Dutiable', flag: 'Failed Deduction', vectorTarget: 'Incoterm / Freight Valuation Variance' },
        ]),
        summary: '<strong>[RECOVERY ALERT] Inland Freight:</strong> DDP shipment to Newnan, GA. Invoice includes $9,000 U.S. inland freight from Port of Savannah. U.S. inland freight is never dutiable.',
        emailSnippet: '<strong>[RECOVERY ALERT] U.S. Inland Freight:</strong> DDP shipment includes $9,000 U.S. inland freight which is strictly non-dutiable. Please deduct to claim a <strong>$450 Duty Recovery</strong>.<br><br>',
      },
      {
        title: 'Triage Required: UOM / Quantity Integrity (Stats. Anomaly)',
        type: 'risk',
        value: 0,
        cleared: false,
        items: withItemFields([
          { part: 'Motorcycle Fuel Tanks', declared: '1,000 KGS', target: '500 NO', flag: 'UOM Mismatch', vectorTarget: 'UOM / Quantity Integrity (Stats. Anomaly)' },
        ]),
        summary: '<strong>[COMPLIANCE RISK] UOM Mismatch.</strong> Broker filed KGS. USITC database strictly mandates NO (Number/Count) for this HTS code. Census Bureau statistical reporting violation.',
        emailSnippet: '<strong>[COMPLIANCE RISK] UOM Error:</strong> Broker filed KGS for Fuel Tanks. USITC mandates NO (Number/Count). Please correct the statistical reporting error.<br><br>',
      },
    ],
    hitl: [
      {
        title: 'Agentic Predictor: Buying Commission',
        desc: '[HITL REQUIRED] Commission fee detected. Verify if this is a non-dutiable bona fide buying commission.',
        actionTitle: 'Verification Required:',
        actionDesc: 'A commission fee was flagged on the Commercial Invoice.',
        vectorsTarget: 'Buying Commission Predictor',
        hitlType: 'buying_commission',
        type: 'hitl',
        value: 0,
        cleared: false,
        resolutionMode: null,
        resolutionReason: null,
      },
    ],
  },
];

const YamahaContext = createContext(null);

export const YamahaProvider = ({ children }) => {
  const [entries, setEntries] = useState(buildInitialEntries);
  const [currentIndex, setCurrentIndex] = useState(0);

  const resolveExceptionItem = (entryIdx, exIdx, itemIdx, mode, reason) => {
    setEntries((prev) =>
      prev.map((e, i) => {
        if (i !== entryIdx) return e;

        const newExceptions = e.exceptions.map((ex, j) => {
          if (j !== exIdx) return ex;
          const newItems = ex.items.map((item, k) =>
            k !== itemIdx
              ? item
              : { ...item, cleared: true, resolutionMode: mode, resolutionReason: reason }
          );
          const allCleared = newItems.every((item) => item.cleared);
          return { ...ex, items: newItems, cleared: allCleared };
        });

        const exception = newExceptions[exIdx];
        let newClassVectors = e.classVectors;
        let newTypeAVectors = e.typeAVectors;
        let newTypeBVectors = e.typeBVectors;
        let newRecovery = e.recoveryValue;
        let newDeficiency = e.deficiencyValue;

        if (exception.cleared) {
          const vTarget = exception.items[itemIdx]?.vectorTarget;
          const anyAccepted = exception.items.some((it) => it.resolutionMode === 'accept');
          const vectorStatus = anyAccepted ? 'accepted' : 'overridden';

          if (vTarget) {
            const upd = (arr) =>
              arr.map((v) => (v.name === vTarget ? { ...v, status: vectorStatus } : v));
            newClassVectors = upd(newClassVectors);
            newTypeAVectors = upd(newTypeAVectors);
            newTypeBVectors = upd(newTypeBVectors);
          }

          if (!anyAccepted && exception.value > 0) {
            if (exception.type === 'recovery')
              newRecovery = Math.max(0, newRecovery - exception.value);
            else if (exception.type === 'risk')
              newDeficiency = Math.max(0, newDeficiency - exception.value);
          }
        }

        return {
          ...e,
          exceptions: newExceptions,
          classVectors: newClassVectors,
          typeAVectors: newTypeAVectors,
          typeBVectors: newTypeBVectors,
          recoveryValue: newRecovery,
          deficiencyValue: newDeficiency,
        };
      })
    );
  };

  const resolveHitl = (entryIdx, hitlIdx, mode, reason) => {
    setEntries((prev) =>
      prev.map((e, i) => {
        if (i !== entryIdx) return e;
        const hitlItem = e.hitl[hitlIdx];
        const vTarget = hitlItem?.vectorsTarget;
        const vectorStatus = mode === 'accept' ? 'accepted' : 'overridden';

        let newRecovery = e.recoveryValue;
        let newDeficiency = e.deficiencyValue;
        if (mode === 'accept') {
          const rawVal = reason.replace(/[^0-9.]/g, '');
          const parsedVal = parseFloat(rawVal);
          if (!isNaN(parsedVal) && parsedVal > 0) {
            if (hitlItem?.hitlType === 'buying_commission') {
              newRecovery += parsedVal * 0.10;
            } else if (hitlItem?.hitlType === 'assist') {
              newDeficiency += parsedVal * 0.05;
            }
          }
        }

        const upd = (arr) =>
          !vTarget ? arr : arr.map((v) => (v.name === vTarget ? { ...v, status: vectorStatus } : v));

        return {
          ...e,
          hitl: e.hitl.map((h, j) =>
            j !== hitlIdx
              ? h
              : { ...h, cleared: true, resolutionMode: mode, resolutionReason: reason }
          ),
          classVectors: upd(e.classVectors),
          typeAVectors: upd(e.typeAVectors),
          typeBVectors: upd(e.typeBVectors),
          recoveryValue: newRecovery,
          deficiencyValue: newDeficiency,
        };
      })
    );
  };

  const clearException = (entryIndex, exceptionIndex) => {
    resolveExceptionItem(entryIndex, exceptionIndex, 0, 'accept', 'Cleared');
  };

  const clearHitl = (entryIndex, hitlIndex) => {
    resolveHitl(entryIndex, hitlIndex, 'override', 'Cleared');
  };

  return (
    <YamahaContext.Provider
      value={{
        entries,
        currentIndex,
        setCurrentIndex,
        resolveExceptionItem,
        resolveHitl,
        clearException,
        clearHitl,
      }}
    >
      {children}
    </YamahaContext.Provider>
  );
};

export const useYamaha = () => {
  const ctx = useContext(YamahaContext);
  if (!ctx) throw new Error('useYamaha must be used within YamahaProvider');
  return ctx;
};

export default YamahaContext;
